/**
 * Default expiry for document↔agent assignment (assign-agent API).
 * Rolling window from "now" so the grant does not expire on a fixed calendar date.
 *
 * @param {number} [yearsFromNow=1]
 * @returns {string} `YYYY-MM-DD HH:mm:ss` (matches prior API usage)
 */
export function getDocumentAssignmentExpiresAt(yearsFromNow = 1) {
  const d = new Date(Date.now() + yearsFromNow * 365 * 24 * 60 * 60 * 1000);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}
